import { useCallback } from 'react'

import { getContinueDisable } from 'components/Editor/EditorElements/utils/getContinueDisable'
import { continueAndHideBlock, continueBlock } from 'services/Store/Project/actions'
import { showIncompleteElementList } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import {
  getBlocksState,
  getBlockState,
  getSection,
  getIncompleteElementsByBlocks,
  getProject,
} from 'services/Store/Project/selectors'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const ContinueButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  block,
  mode,
  styles,
  font,
  children,
}) => {
  const dispatch = useProjectDispatch()
  const blockState = useProjectContext(getBlockState, block?.uuid)
  const blocks = useProjectContext(getBlocksState)
  const section = useProjectContext(getSection)
  const hasResult = Boolean(blockState?.result)

  const showIncompleteModal = useProjectContext(getProject)?.displayIncompleteModal

  const prevBlocks =
    section?.blocksOrder.slice(0, section?.blocksOrder.indexOf(block?.uuid || '') || 0) || []

  const incompleteElements = useProjectContext(getIncompleteElementsByBlocks, prevBlocks)

  const label = !hasResult ? element?.value?.label : element?.value?.secondLabel
  const condition = element.value.condition || 'none'

  const disabled = getContinueDisable({ block, condition, blocks, section })

  const onClick = useCallback(() => {
    if (disabled && showIncompleteModal && incompleteElements.length) {
      dispatch(showIncompleteElementList())
    } else if (block) {
      if (element.value.showBlock) {
        dispatch(continueBlock({ blockId: block.uuid }))
      } else {
        dispatch(continueAndHideBlock({ blockId: block.uuid }))
      }
    }
  }, [dispatch, block, incompleteElements, disabled, showIncompleteModal, element.value.showBlock])

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={(!showIncompleteModal && disabled) || blockState?.continueCompleted}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default ContinueButtonElement
